var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", [
        _vm.comments
          ? _c(
              "div",
              { staticClass: "flex items-center justify-between gap-2" },
              [
                _c("span", { attrs: { id: "comment-text" } }, [
                  _vm._v(_vm._s(_vm.comments)),
                ]),
                _c(
                  "vx-tooltip",
                  {
                    attrs: {
                      text: "Editar o ver comentario",
                      placement: "top",
                    },
                  },
                  [
                    _c("vs-button", {
                      attrs: {
                        color: "dark",
                        type: "border",
                        icon: "edit",
                        size: "small",
                        disabled: !_vm.checkEditingPermissions(),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onPopupComments($event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _c("div", [
              _c("p", { staticClass: "text-grey" }, [
                _vm._v("Sin comentarios"),
              ]),
            ]),
      ]),
      _c(
        "vs-popup",
        {
          staticClass: "content-display-comments",
          attrs: { title: _vm.title, active: _vm.popupActive },
          on: {
            "update:active": function ($event) {
              _vm.popupActive = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col gap-2" },
            [
              _c("vs-textarea", {
                attrs: {
                  rows: 7,
                  counter: "240",
                  maxlength: 240,
                  disabled: !_vm.checkEditingPermissions(),
                },
                model: {
                  value: _vm.editingComments,
                  callback: function ($$v) {
                    _vm.editingComments = $$v
                  },
                  expression: "editingComments",
                },
              }),
              _c(
                "div",
                { staticClass: "flex justify-end gap-2" },
                [
                  _c(
                    "vs-button",
                    {
                      staticClass: "hover:bg-grey-light",
                      attrs: { color: "grey", type: "border", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onPopupComments($event)
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "vs-button",
                    {
                      attrs: {
                        color: "success",
                        size: "small",
                        disabled: _vm.loading || !_vm.checkEditingPermissions(),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateComments()
                        },
                      },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }